import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {StyledEventRow, StyledEventsList} from './style'

export const HomeEventsSkeleton = () => {
    return (
        <StyledEventsList>
            {Array.from({length: 4}).map((_, index) => (
                <StyledEventRow key={index}>
                    <Skeleton width={90} height={16} />
                    <Skeleton width={160} height={16} />
                    <Skeleton width={120} height={16} />
                </StyledEventRow>
            ))}
        </StyledEventsList>
    )
}
